import React from "react";
import PropTypes from 'prop-types';

import useStyles from './styles';

const Button = ({title, disabled , handleSubmit}) => {
    
    const classes = useStyles();

    return (
        <button disabled={disabled} className={classes.button} onClick={handleSubmit}>
            {title}
        </button>
    );
};

Button.propTypes = {
    title: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    disabled: PropTypes.bool.isRequired
};

export default Button;